import React, { useState } from "react";
import { currencyFormatter } from "../common/Utils";
import ApiService from "../../services/api.service";
import Loader from "../common/Loader";
import { Toaster } from "./ViewTransactions";
import { ToastContainer, toast } from 'react-toastify';
import axios from "axios";
function SuccessPostLogin(data) {
  const [loader, showLoader] = useState(false)
  const exportFile = () => {
        let type = "pdf";
        showLoader(true);
        try {
          let payload = {
            reference: data.data.reference_num
          };
          ApiService.file("/farmer/transactionsDetails/report", payload).subscribe(
            (res) => {
              if (res.data !== undefined && res.data !== null) {
                showLoader(false);
                if (type == "pdf") {
                  let blob;
                  var arrBuffer = res.data;
                  blob = new Blob([arrBuffer], { type: "application/pdf" });
                  const downloadURL = window.URL.createObjectURL(blob);
                  window.open(downloadURL);
                } 
              } else {
                showLoader(false);
                Toaster('error', "Unable to get Report");
              }
            }
          );
        } catch (e) {
          showLoader(false);
          console.log("An error occurred" + e);
        } finally {
        }
      };
    return (
        <div className="wrapper-success">
            <Loader loader={loader} />
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            {/* Same as */}
            <ToastContainer />
            <div className="success_mapper"></div>
            <div className="success post">
                <div className="success_wrapper">
                    <h5 className="success_wrapper_heading">{data.data.modaltype ? data.data.modaltype : "Success"}</h5>

                    <p className="success_wrapper_message post-message">
                        Ref Number: <strong> {data.data.reference_num} </strong>
                    </p>
                    <p className="success_wrapper_message post-message">
                        Date: <strong>{data.data.date}</strong>
                    </p>
                    <div className="success_wrapper_icon">
                        <svg id="icon-check1" height="70" width="70" viewBox="0 0 24 24">
                        </svg>
                    </div>
                    <p className="success_wrapper_message post-message">
                        <strong>{data.data.amount}</strong>
                    </p>
                    <p className="success_wrapper_message post-message">
                        {data.data.farmer_identity}
                    </p>
                    <p className="success_wrapper_message post-message">
                        {data.data.phone}
                    </p>
                    <p className="success_wrapper_message post-message">
                        Wallet balance: <strong>{currencyFormatter(data.data.balance)} Kes</strong>
                    </p>
                    <div className="summary_wrapper_success">
                        <button onClick={(e) => { e.preventDefault(); exportFile(); }} className="verify_wrapper_form_btn_verify select back">
                            DOWNLOAD RECEIPT
                        </button>
                        <button onClick={data.data.action} className={`verify_wrapper_form_btn_verify select next`}>
                            DONE
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
  }

  export default SuccessPostLogin;
